module.exports = __webpack_public_path__ + "static/img/gywm_gsjj_img_three.35ce1f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gywm_gsjj_img_three.png
// module id = etGQ
// module chunks = 21